<h3 class="ui header light user-step-title">Learning Outcomes Mapping</h3>


<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.message"></app-loading>
</div>

<ng-template #loaded>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>

  <ng-template #noErrors>

    <!-- 
    <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
    </app-action-errors> -->


    <div class="user-step-instruction">
      In this section you will map the course outcomes to program-level learning outcomes using the mapping scale
      below.
      For each point of alignment, indicate the degree to which a program-level learning outcome is addressed by a
      particular
      course outcome.
    </div>



    <div>

      <div class="levels-table">

        <div class="subsection-title">Mapping Scale</div>

        <div class="mapping-scale-content">

          <!-- <div class="level-description">The table below is a scale that is used to indicate the degree to which a program-level learning outcome is addressed
            by a course outcome.</div> -->

          <table class="ui table celled ">
            <tr *ngFor="let level of levels">
              <td class="level-name-col">
                <div class="square" [ngStyle]="{'background-color': level.bgColor, 'color': level.fontColor}"></div>
                {{level.name}} ({{level.abbreviation}})
              </td>
              <td class="level-desc-col">{{level.description}}</td>
            </tr>
          </table>

        </div>

      </div>

      <div class="course-outcome-table-container">
        <div class="subsection-title">Outcome Mapping</div>
        <div class="course-outcome-description">

          <div class="instructions-title">Instructions</div>
          <div class="instructions-description">Course outcomes you added in the previous step are listed below.
            Underneath each course outcome, the program-level learning outcomes (PLOs) are listed along with radio
            buttons to
            designate the mapping scale.
          </div>

          <div class="instructions-description">For each course outcome, indicate the level of complexity or depth that
            it aligns with each PLO, if at all. If the course outcome does not align with a PLO, leave the radio button
            at NA (no alignment).
          </div>

          <div class="instructions-description">Note: Indicate only where there is a MODERATE to STRONG alignment, not
            a weak one, and a DIRECT alignment, not
            peripheral. It is normal and expected for there to be many places where
            course outcomes do not align with PLOs.
          </div>

        </div>

        <div class="course-outcome-map-tables" *ngIf="outcomeMapsArray && outcomeMapsArray.length > 0">

          <div class="ui segment" *ngFor="let courseOutcome of courseOutcomeMaps; let i = index">

            <div>
              <div class="course-outcome-index">Course Outcome #{{i+1}}</div>
              <div>{{courseOutcome.description}}</div>
            </div>

            <table class="ui table celled">

              <tr class="header-row">
                <td>Program-level Learning Outcome
                </td>
                <td *ngFor="let level of levels" class="level-col">{{level.abbreviation}}</td>
                <td class="level-col ">NA</td>
              </tr>


              <ng-container *ngIf="programOutcomeCategories.length > 0">

                <ng-container *ngFor="let ploCategory of programOutcomesByCategory">

                  <tr class="category-row">
                    <td [colSpan]="levels.length + 2">
                      {{ploCategory.category.name}}
                    </td>
                  </tr>

                  <tr *ngFor="let plo of ploCategory.outcomes">

                    <td>
                      <div class="plo-title">{{plo.index}}. {{plo.title}}</div>
                      <div class="plo-description" *ngIf="plo.description">{{plo.description}}</div>
                    </td>

                    <td *ngFor="let level of levels" class="level-col">
                      <div class="ui fitted radio checkbox">
                        <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, level)"
                          [attr.name]="'level-' + courseOutcome.id + '-' + plo.id"
                          [checked]="outcomeMapsArray[courseOutcome.id][plo.id] && outcomeMapsArray[courseOutcome.id][plo.id].id == level.id">
                        <label></label>
                      </div>
                    </td>
                    <td class="level-col not-applicable">
                      <div class="ui fitted radio checkbox">
                        <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, null)"
                          [attr.name]="'level-' + courseOutcome.id + '-' + plo.id"
                          [checked]="!outcomeMapsArray[courseOutcome.id][plo.id]">
                        <label></label>
                      </div>
                    </td>

                    <!-- <ng-container *ngFor="let ploCategory of programOutcomesByCategory"> -->
                    <!-- <tr *ngFor="let plo of ploCategory.plos"></tr>
                  <td>
                    <div class="plo-title">{{plo.index}}. {{plo.title}}</div>
                    <div class="plo-description" *ngIf="plo.description">{{plo.description}}</div>
                  </td>
                  <td *ngFor="let level of levels" class="level-col">
                    <div class="ui fitted radio checkbox">
                      <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, level)"
                        [attr.name]="'level-' + courseOutcome.id + '-' + plo.id" [checked]="outcomeMapsArray[courseOutcome.id][plo.id] && outcomeMapsArray[courseOutcome.id][plo.id].id == level.id">
                      <label></label>
                    </div>
                  </td>
                  <td class="level-col not-applicable">
                    <div class="ui fitted radio checkbox">
                      <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, null)"
                        [attr.name]="'level-' + courseOutcome.id + '-' + plo.id" [checked]="!outcomeMapsArray[courseOutcome.id][plo.id]">
                      <label></label>
                    </div>
                  </td>

                  </tr> 

                  </ng-container> -->

                  </tr>

                </ng-container>

                <ng-container *ngIf="programOutcomesWithoutCategory.length > 0">
                  <tr class="category-row">
                    <td [colSpan]="levels.length + 2">No Category</td>
                  </tr>
                  <tr *ngFor="let plo of programOutcomesWithoutCategory">
                    <td>
                      <div class="plo-title">{{plo.index}}. {{plo.title}}</div>
                      <!-- <div class="plo-description" *ngIf="plo.description">{{plo.description}}</div> -->
                    </td>
                    <td *ngFor="let level of levels" class="level-col">
                      <div class="ui fitted radio checkbox">
                        <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, level)"
                          [attr.name]="'level-' + courseOutcome.id + '-' + plo.id"
                          [checked]="outcomeMapsArray[courseOutcome.id][plo.id] && outcomeMapsArray[courseOutcome.id][plo.id].id == level.id">
                        <label></label>
                      </div>
                    </td>
                    <td class="level-col not-applicable">
                      <div class="ui fitted radio checkbox">
                        <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, null)"
                          [attr.name]="'level-' + courseOutcome.id + '-' + plo.id"
                          [checked]="!outcomeMapsArray[courseOutcome.id][plo.id]">
                        <label></label>
                      </div>
                    </td>
                  </tr>
                </ng-container>

              </ng-container>

              <ng-container *ngIf="programOutcomeCategories.length == 0">
                <tr *ngFor="let plo of programOutcomesWithoutCategory">
                  <td>
                    <div class="plo-title">{{plo.title}}</div>
                    <div class="plo-description" *ngIf="plo.description">{{plo.description}}</div>
                  </td>
                  <td *ngFor="let level of levels" class="level-col">
                    <div class="ui fitted radio checkbox">
                      <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, level)"
                        [attr.name]="'level-' + courseOutcome.id + '-' + plo.id"
                        [checked]="outcomeMapsArray[courseOutcome.id][plo.id] && outcomeMapsArray[courseOutcome.id][plo.id].id == level.id">
                      <label></label>
                    </div>
                  </td>
                  <td class="level-col not-applicable">
                    <div class="ui fitted radio checkbox">
                      <input type="radio" name="radio" (change)="valueChanged(courseOutcome.id, plo.id, null)"
                        [attr.name]="'level-' + courseOutcome.id + '-' + plo.id"
                        [checked]="!outcomeMapsArray[courseOutcome.id][plo.id]">
                      <label></label>
                    </div>
                  </td>
                </tr>
              </ng-container>

            </table>

          </div>

          <div class="save-button">
            <span class="status-text" *ngIf="formProcessing">Saving...</span>
            <!-- <span class="status-text" *ngIf="justSaved && !isValueChanged">
              <i class="check icon"></i>Outcome maps saved successfully.</span> -->
            <span class="status-text" *ngIf="isValueChanged && !formProcessing">
              <i class="exclamation triangle icon"></i>Please save your changes.</span>
            <span class="status-text" *ngIf="justSaved">
              <i class="check icon"></i>Changes have been saved successfully.
            </span>
            <button class="ui button primary tiny" (click)="saveOutcomeMaps()"
              [ngClass]="{'loading': formProcessing, 'disabled' : formProcessing || !isValueChanged}">Save</button>
          </div>

        </div>

      </div>

    </div>


    <!-- <div class="button-area">

      <div class="nav-button-area">
        <button class="ui left labeled icon button tiny prev-step-button" (click)="previousStepClicked()">
          <i class="left arrow icon"></i>Previous - Course outcomes</button>
        <button class="ui right labeled icon  button tiny next-step-button" (click)="nextStepClicked()">
          <i class="right arrow icon"></i>Next - Additional questions</button>
      </div>

    </div> -->

  </ng-template>


</ng-template>